import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import HTMLView from 'Components/HTMLView';

import { Flex } from '../Base';

const MaintenanceView = ({ announcement }) => {
  return (
    <Flex flexDirection="column" alignItems="center" p={10}>
      <HTMLView rawContent={announcement} />
    </Flex>
  );
};

MaintenanceView.propTypes = {
  announcement: PropTypes.string,
};

MaintenanceView.defaultProps = {
  announcement: '',
};

export default withRouter(MaintenanceView);
